module.exports = __webpack_public_path__ + "media/images/okra-offers/Rewards-Earn-04-4fee2bd49aa65d03471befbb105575aa.jpg";